import * as Yup from "yup";

export const queryValidation = Yup.object().shape({
  name: Yup.string().required("Required"),
  organisationName: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  phoneNumber: Yup.string()
    .nullable()
    .min(10, "Invalid number")
    .max(10, "Invalid number")
    .required("Required"),
  query: Yup.string()
    .max(500, "Query must be less than 500 character")
    .required("Required"),
});
